import {
	Component,
	EventEmitter,
	Input,
	Output
}                                from '@angular/core';
import { BaseComponent }         from '@core/bases/base-component/base.component';
import {
	FilterSwitchType,
	IActiveFilterData,
	IFilter
}                                from '@shared/list-operations/model/filter.model';
import {
	ListOperationsIdentifierEnum,
	ListOperationsResetEnum,
	ListOperationsResetModeEnum,
	ListOperationsResetType
}                                from '@shared/list-operations/model/list-operations.model';
import { ListOperationsService } from '@shared/list-operations/services/list-operations.service';
import { Subscription }          from 'rxjs';
import { takeUntil }             from 'rxjs/operators';

@Component( {
	selector: 'app-switch-filter[listOperationIdentifier]',
	templateUrl: './switch-filter.component.html',
	styleUrls: [ './switch-filter.component.scss' ]
} )
export class SwitchFilterComponent extends BaseComponent {

	private _defaultFilterData: IFilter;

	private _id: number;

	private _listOperationIdentifier: ListOperationsIdentifierEnum;

	private _resetListOperationsSubscription: Subscription;

	switchFilterValue: FilterSwitchType;

	@Input() set defaultFilterData( defaultFilterData: IFilter ) {
		this.initialize( defaultFilterData );
	}

	get listOperationIdentifier(): ListOperationsIdentifierEnum {
		return this._listOperationIdentifier;
	}

	@Input()
	set listOperationIdentifier( listOperationIdentifier: ListOperationsIdentifierEnum ) {
		if ( !listOperationIdentifier ) { return; }

		this._listOperationIdentifier = listOperationIdentifier;

		this._resetListOperationsSubscription?.unsubscribe();

		this._resetListOperationsSubscription =
			this.listOperationsService.select.resetListOperationsData(
				listOperationIdentifier,
				'SwitchFilterComponent:set listOperationIdentifier'
			)
			.pipe(
				takeUntil( this.ngUnsubscribe )
			)
			.subscribe( ( resetData: ListOperationsResetType ) => {
				if (
					resetData?.listOperator === ListOperationsResetEnum.ALL ||
					resetData?.listOperator === ListOperationsResetEnum.FILTERS_ALL ||
					(
						resetData?.listOperator === ListOperationsResetEnum.FILTER &&
						resetData?.identifier === this._id
					)
				) {

					switch ( resetData.resetMode ) {
						case ListOperationsResetModeEnum.CLEAR:
							this.clearControlValue();
							break;

						case ListOperationsResetModeEnum.DEFAULT:
						case ListOperationsResetModeEnum.RESTORE:
							this.resetFilter( resetData.resetMode );
							break;
					}
				}
			} );
	}

	@Output() filterItemChange: EventEmitter<IActiveFilterData> = new EventEmitter();

	constructor(
		private readonly listOperationsService: ListOperationsService
	) {
		super();
	}

	private initialize( defaultFilterData: IFilter ): void {
		this._defaultFilterData = defaultFilterData;
		this._id = defaultFilterData?.id;
		if ( defaultFilterData?.values?.length ) {
			this.switchFilterValue = defaultFilterData.values[ 0 ] as FilterSwitchType;
		}
	}

	private clearControlValue(): void {
		this.switchFilterValue = null;
	}

	private resetFilter( resetMode: ListOperationsResetModeEnum ): void {

		const resetData: IFilter = this.listOperationsService.helper.filterResetDataByResetMode(
			this.listOperationIdentifier,
			this._id,
			resetMode
		);

		if ( resetData?.values?.length ) {
			this.switchFilterValue = resetData?.values[ 0 ] as FilterSwitchType;
		} else {
			this.clearControlValue();
		}
	}

	private get prepareSwitchFilterDataForEmit(): IActiveFilterData {
		return {
			param: this.switchFilterValue
		};
	}

	onSwitchChange( switchValue: boolean ): void {
		this.switchFilterValue = switchValue;
		this.filterItemChange.emit( this.prepareSwitchFilterDataForEmit );
	}
}
